import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/combination-calculator',
  component: () => import('../../routes/CombinationCalculator.svelte'),
  card: {
    id: 'combination-calculator',
    title: 'Combination Calculator',
    description: 'Calculate the number of ways to choose r elements from n elements without regard to order (nCr).',
    icon: 'auto_awesome',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/combination-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Combination Calculator – nCr Calculator with Step-by-Step Breakdown',
    description: 'Free combination calculator. Compute unordered selections (nCr) and permutations (nPr) with step-by-step breakdown, digit count, and ln(nCr). Perfect for combinatorics and probability calculations.',
  },
};

export default meta;